import React from "react";
import { Link } from "react-router-dom";

const DonationButton = ({ className, children }) => {
  return (
    <Link to="/donation" className={className}>
      {children || "Donar"}
    </Link>
  );
};

export default DonationButton;
